import session from './session';

export default {
    rooms() {
        return session.get('/api/chats/');
    },
    messages(room_id, messagesPage) {
        return session.get(`/api/chats/${room_id}/messages/`, { params: { 'page': messagesPage } });
    },

    // DEPRECATED
    send_message(room_id, message) {
        let content = message.content;
        let reply = null;
        let uri = message.uri;
        if (message.replyMessage) {
            reply = message.replyMessage._id;
        }
        return session.post(`/api/chats/${room_id}/messages/`, { content, reply, uri })
    },
    // DEPRECATED
    patch_message(room_id, messageId, newContent) {
        return session.patch(`/api/chats/${room_id}/messages/${messageId}/`, { 'content':newContent })
    },
    delete_message(room_id, messageId) {
        return session.delete(`/api/chats/${room_id}/messages/${messageId}/`)
    },

    send_file(roomId, messageId, formated_file) {
        let formData = new FormData();
        let audio = false;
        let filename = `${formated_file.name}.${formated_file.extension}`
        if (formated_file.type === "audio/mp3") {
            audio = true;
            if (formated_file.name.indexOf('mp3') + 1) {
                filename = formated_file.name;
            }
        }

        let file = new File([formated_file.blob], filename);

        formData.append('file', file, filename);
        formData.append('chat', roomId);
        formData.append('message', messageId);
        formData.append('uri', formated_file.uri);
        formData.append('audio', audio);

        return session.post(`/api/chats/files/`,
            formData, {
                    headers: {
                      'Content-Type': `multipart/form-data`,
                    },
                })

    },
    delete_file(fileId) {
      return session.delete(`/api/chats/files/${fileId}/`)
    },
    get_reaction(messageId, reaction) {
      return session.get('/api/chats/reactions/', { params: { 'message': messageId, 'emoji': reaction } })
    },
    add_reaction(room_id, messageId, user_id, reaction) {
        return session.post('/api/chats/reactions/',
            {'chat': room_id, 'message': messageId, 'users': [user_id], 'reaction': reaction})
    },
    put_reaction(reaction) {
        return session.put(`/api/chats/reactions/${reaction.id}/`, {...reaction})
    },
    delete_reaction(reactionId) {
        return session.delete(`/api/chats/reactions/${reactionId}/`)
    }


}